/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DetectPromptEntitiesRequest
 */
export interface DetectPromptEntitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof DetectPromptEntitiesRequest
     */
    prompt: string;
}

/**
 * Check if a given object implements the DetectPromptEntitiesRequest interface.
 */
export function instanceOfDetectPromptEntitiesRequest(value: object): value is DetectPromptEntitiesRequest {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    return true;
}

export function DetectPromptEntitiesRequestFromJSON(json: any): DetectPromptEntitiesRequest {
    return DetectPromptEntitiesRequestFromJSONTyped(json, false);
}

export function DetectPromptEntitiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetectPromptEntitiesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
    };
}

export function DetectPromptEntitiesRequestToJSON(value?: DetectPromptEntitiesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'prompt': value['prompt'],
    };
}

